
import React from 'react';
import { getFromSession, saveInSession, logout } from '../../controller/session';
import { Button, ButtonGroup } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import './auth.css';
import { Redirect } from "react-router-dom";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

export function salirForm(logout) {

  sessionStorage.clear();
  window.location.replace("https://www.comfenalcovalle.com.co/");///`${process.env.REACT_APP_URL_LOGOUT}${process.env.REACT_APP_ID}`;
  return;
}

function renderForm(callbackPath, urlRedirect, children, logout) {
  return (
    <div className="auth-wrapper">
      <Redirect to={callbackPath}></Redirect>
      <div className="button-nav-bandeja">
        <ButtonGroup color="primary" aria-label="primary button group">
          <Button onClick={() => salirForm(logout)}>
            <ExitToAppIcon />
          </Button>
        </ButtonGroup>
      </div>
      {
        children
      }

    </div>
  );
}

function LoginButtonFirebase({ urlRedirect, callbackPath, children, firebaseUser, colaboradorUser }) {
  const params = window.location.search.slice(1).split('&').reduce((acc, s) => {
    const [k, v] = s.split('=')
    return Object.assign(acc, { [k]: v })
  }, {})


  if (params.user && !colaboradorUser) {
    sessionStorage.clear();
    saveInSession('authUserColaborador', { user: { ...params }, type: "firebase" });
  }

  if (colaboradorUser) {
    saveInSession('authUserColaborador', colaboradorUser);
  }


  const isAuthenticated = getFromSession('authUserColaborador');
  const isInitializatedForm = getFromSession('formInitilizated');

  // console.log('isAuthenticated', isAuthenticated);
  // console.log('isInitializatedForm', isInitializatedForm);

  if ((isAuthenticated && isAuthenticated.user) || isInitializatedForm) {
    return renderForm(callbackPath, urlRedirect, children);

  } else {

    if (colaboradorUser) {
      return renderForm(callbackPath, urlRedirect, children);
    } else {
      return window.location.href = `${process.env.REACT_APP_URL_LOGIN_COLABORADOR_FIREBASE}${process.env.REACT_APP_ID_COLABORADOR_ACTUALIZACIONES_FIREBASE}&tipo=C`;
    }
  }


}



export default LoginButtonFirebase;

